import {
  styled,
  ToggleButton as MuiToggleButton,
  ToggleButtonProps as MuiToggleButtonProps,
} from "@mui/material";

const StyledButton = styled(MuiToggleButton)(({ theme }) => {
  return {
    height: "2.5rem",
    width: "10rem",
    border: `2px solid ${theme.palette.toggleButton.background}`,
    borderRadius: "0.5rem",
    textTransform: "none",
    fontWeight: 600,
    color: theme.palette.brandedTypography.textColor,
    "&.Mui-selected": {
      backgroundColor: theme.palette.toggleButton.background,
      color: theme.palette.toggleButton.textColor,
      "&:hover": {
        backgroundColor: theme.palette.toggleButton.hoverBackground,
      },
    },
  };
});

interface ButtonProps extends MuiToggleButtonProps {
  children: React.ReactNode;
}

export const ToggleButton: React.FC<ButtonProps> = ({ children, ...props }) => {
  return <StyledButton {...props}>{children}</StyledButton>;
};

export default ToggleButton;
